function Home () {
	return (
		<span/>
	);
}

export default Home;